import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Store } from '@ngrx/store';
import { Logo } from '../models/logo.model';
import { ServerResponse } from '../models/types';

@Injectable()
export class UploadFileService {
    url = '';

    constructor(
        private http: HttpClient,
        @Inject('BASE_URL') baseUrl: string,
        private storeLG: Store<Logo>
    ) {
        this.url = baseUrl;
    }

  async getFileName() {

    return this.http.get(this.url + 'api/Upload_Logo/getLogo').toPromise()
      .then((result: ServerResponse) => {
        if (result[0].code === 1) {
          this.storeLG.dispatch({ type: 'INIT_LOGO', lg: result[0].data });
          return result[0].data;
        } else {
          return null;
        }
      })
      .catch(error => { console.log(error); });
    }

    async uploadFile_Sale_FTP(name:string, data: string)
    {
      return this.http.post(this.url + 'api/HoaDon/uploadFileBackUp', { name: name, data: data })
      .toPromise()
      .then((result: ServerResponse) => {
        if (result[0].code === 1) {
          // this.storeLG.dispatch({ type: 'INIT_LOGO', lg: result[0].data });
          return result[0].data;
        } else {
          return null;
        }
      })
      .catch(error => { console.log(error); });
    }

  async uploadFile_Sale_FTP_MACQT(name: string, data: string) {
    return this.http.post(this.url + 'api/HoaDon/uploadFileBackUp_MACQT', { name: name, data: data })
      .toPromise()
      .then((result: ServerResponse) => {
        if (result[0].code === 1) {
          // this.storeLG.dispatch({ type: 'INIT_LOGO', lg: result[0].data });
          return result[0].data;
        } else {
          return null;
        }
      })
      .catch(error => { console.log(error); });
  }
}



// WEBPACK FOOTER //
// ./src/app/services/upload-file.service.ts